/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tim_S1Inputs */

const en_mk_tut_tim_s1 = /** @type {(inputs: Mk_Tut_Tim_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At the bottom of the left menu press **Invite member**, enter the email address, pick a role, and press Invite.`)
};

const id_mk_tut_tim_s1 = /** @type {(inputs: Mk_Tut_Tim_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di menu kiri paling bawah, tekan **Undang anggota**, masukkan alamat email, pilih perannya, lalu tekan Undang.`)
};

/**
* | output |
* | --- |
* | "At the bottom of the left menu press **Invite member**, enter the email address, pick a role, and press Invite." |
*
* @param {Mk_Tut_Tim_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tim_s1 = /** @type {((inputs?: Mk_Tut_Tim_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tim_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tim_s1(inputs)
	return en_mk_tut_tim_s1(inputs)
});